/* eslint-disable import/no-mutable-exports */
var overviewMobilePanel = {
  init: function (stickybits) {

  	function openMobileFilterPanel(){
	  	$('.vorhaben-mobile-menu-panel-filter').addClass('active');
  	}
  	function closeMobileFilterPanel(){
	  	$('.vorhaben-mobile-menu-panel-filter').removeClass('active');
  	}
  	
  	if( $('.vorhaben-mobile-menu-panel-filter').length > 0 && $('.overview-right-panel').length > 0 ) {

	  	if( $(window).width() < 992 ) {
  			switchToMobileMode();
  		}

	  	function switchToMobileMode(){
	  		if( $(window).width() < 992 ) {
	  			if ($('.overview-list-wrapper .col:last-child .overview-right-panel').length > 0 ) {
			  		$('.vorhaben-mobile-menu-panel-filter').append( $('.overview-right-panel') );
	
				  	//on trigger open mobile-filter-mpanel
				  	$('.vorhaben-mobile-menu-panel-trigger .mobile-panel-trigger').click(function(e){
				  		e.preventDefault();
				  		openMobileFilterPanel();
				  	});
				  	//on trigger close mobile-filter-panel
				  	$('.vorhaben-mobile-menu-panel-filter .mobile-panel-close').click(function(e){
				  		e.preventDefault();
				  		closeMobileFilterPanel();
				  	});
				  	$('.vorhaben-mobile-menu-panel-filter .overview-right-panel .filter-submit').click(function(e){
				  		closeMobileFilterPanel();
				  	});
			  	}
		  	}
	  	}
	  	function switchToDesktopMode(){
		  	if( $(window).width() > 991 ) {
	  			if ($('.vorhaben-mobile-menu-panel-filter .overview-right-panel').length > 0 ) {
	  				$('.overview-list-wrapper > .col:last-child').append( $('.overview-right-panel') );
	  			}
	  			stickybits('.overview-left-panel', { useStickyClasses: true , stickyBitStickyOffset: 260 });
		  	}
	  	}

	  	//resize between viewports
	  	var resizeTimer = false;
	  	$(window).on('resize', function(e) {
	  	  if( !resizeTimer ) {
	  		$(window).trigger('resizestart');  	
	  	  }
	  	  clearTimeout(resizeTimer);
	  	  resizeTimer = setTimeout(function() {
	  		resizeTimer = false;
	  		$(window).trigger('resizeend');
	  	  }, 750);
	  	}).on('resizestart', function(){
	  	}).on('resizeend', function(){
		  	if( $(window).width() < 992 ) {
	  			switchToMobileMode();
	  		}else{
	  			switchToDesktopMode();
	  		}
	  	});

  	}
  	

  }
};

export default overviewMobilePanel;